module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/theme-3-224ef943db8248b21bb224f9e6dd163b.webp";